import { useMemo } from "react";
import {
  simulateProgram,
  type Exercise,
  type Program,
  type ProgramSimulation,
} from "@heraion/shared";

import { pairCache } from "./pairCache";

// #492 F5: one simulation per (program, catalog) object pair, for the preview and ProgramPlanGaps.
const simulationOf = pairCache<Program, ReadonlyArray<Exercise>, ProgramSimulation>();

/** The program as written, on an athlete with no history. Null: no catalog. */
export function useProgramSimulation(
  program: Program,
  catalog: ReadonlyArray<Exercise> | null,
): ProgramSimulation | null {
  return useMemo(() => (catalog ? simulationOf(program, catalog, () => simulateProgram(program, catalog)) : null), [program, catalog]);
}
